/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';

import {
  ADD_ROOF_STAGE_ONE,
  ADD_ROOF_STAGE_THREE,
  ADD_ROOF_STAGE_TWO,
  CHECK_DUPLICATE,
  DELETE_ROOF_DATA,
  DELETE_ROOF_STAGE_THREE,
  DELETE_ROOF_STAGE_TWO,
  GET_ROOF_LIST,
  GET_ROOF_NUMBERS,
  GET_ROOF_NUMBERS_FOR_STAGE_TWO,
  GET_ROOF_STAGE_ONE,
  GET_ROOF_STAGE_THREE,
  GET_ROOF_STAGE_TWO,
  GET_ROOF_THREE_LIST,
  GET_ROOF_TWO_LIST,
  GET_VIEW_ROOF_STAGE_ONE_DATA,
  GET_VIEW_ROOF_STAGE_THREE_DATA,
  GET_VIEW_ROOF_STAGE_TWO_DATA,
  ROOF_FLOW_HISTORY,
  UPDATE_ROOF_STAGE_FLOW,
  DELETE_ROOF_DATA_DETAILS,
} from '../../../api/apiConstant';

export const fetchroofStageOneForm = createAsyncThunk(
  'roof/fetchroofStageOneForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_ROOF_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const fetchroofStageTwoForm = createAsyncThunk(
  'roof/fetchroofStageTwoForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_ROOF_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const fetchroofStageThreeForm = createAsyncThunk(
  'roof/fetchroofStageThreeForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_ROOF_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const addRoofStageTwoData = createAsyncThunk(
  'roof/addRoofStageTwoData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ROOF_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

// ==================== ADD DATA ====================
export const addRoofStageOneData = createAsyncThunk(
  'roof/addRoofStageOneData',
  async (formData, { rejectWithValue }) => {
    try {
       console.log("form1Roof",formData);
      const response = await api.post(ADD_ROOF_STAGE_ONE, formData);
      console.log(78,response)
      return response.data;
    } catch (error) {
      console.log("data1roof",error);
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to add stage one data',
      );
    }
  },
);

// ==================== FETCH LIST ====================
export const fetchRoofList = createAsyncThunk(
  'roof/fetchRoofList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ROOF_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch roof list');
    }
  },
);

export const deleteRoofData = createAsyncThunk(
  'roof/deleteRoofData',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_ROOF_DATA}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to delete roof data');
    }
  },
);

//delete roof staGE TWO
export const deleteRoofStageTwoData = createAsyncThunk(
  'roof/deleteRoofStageTwoData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_ROOF_STAGE_TWO}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchRoofTwoList = createAsyncThunk(
  'roof/fetchRooftwoList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ROOF_TWO_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch roof Two list',
      );
    }
  },
);

export const fetchRoofNumbersForStageTwo = createAsyncThunk(
  'roof/fetchRoofNumbersForStageTwo',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ROOF_NUMBERS_FOR_STAGE_TWO, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch roof numbers',
      );
    }
  },
);


export const addRoofStageThreeData = createAsyncThunk(
  'roof/addRoofStageThreeData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ROOF_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to add stage three data',
      );
    }
  },
);

export const fetchRoofThreeList = createAsyncThunk(
  'roof/fetchRoofThreeList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ROOF_THREE_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch roof three list',
      );
    }
  },
);

export const deleteRoofStageThreeData = createAsyncThunk(
  'roof/deleteRoofStageThreeData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_ROOF_STAGE_THREE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const UpdateRoofFlowStatus = createAsyncThunk(
  'roof/UpdateRoofFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ROOF_STAGE_FLOW, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow status',
      );
    }
  },
);

// Add this to your roofThunk.js
export const fetchRoofFlowHistory = createAsyncThunk(
  'roof/fetchRoofFlowHistory',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ROOF_FLOW_HISTORY, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history'
      );
    }
  },
);

//------------------------------- view roof ------------------

export const fetchViewRoofStageOne = createAsyncThunk(
  'roof/fetchViewRoofStageOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_ROOF_STAGE_ONE_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history'
      );
    }
  },
);
export const fetchViewRoofStageTwo = createAsyncThunk(
  'roof/fetchViewRoofStageTwo',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_ROOF_STAGE_TWO_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history'
      );
    }
  },
);
export const fetchViewRoofStageThree = createAsyncThunk(
  'roof/fetchViewRoofStageThree',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_ROOF_STAGE_THREE_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history'
      );
    }
  },
);

export const fetchRoofNumbers = createAsyncThunk(
  'roof/fetchRoofNumbers',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ROOF_NUMBERS, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch roof number');
    }
  },
);


export const checkDuplicate = createAsyncThunk(
  'common/checkDuplicate',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(CHECK_DUPLICATE, payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);
export const deleteRoofDetails = createAsyncThunk(
  'furnishing/deleteRoofDetails',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_ROOF_DATA_DETAILS, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);
